import SpeakSheet from './SpeakSheet';

SpeakSheet.install = function(Vue) {
  Vue.component(SpeakSheet.name, SpeakSheet);
};

export default SpeakSheet;
